import { render, staticRenderFns } from "./generic-banner-youtube-player.vue?vue&type=template&id=de815600"
import script from "./generic-banner-youtube-player.vue?vue&type=script&lang=js"
export * from "./generic-banner-youtube-player.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports